<template>
  <div class="b1">
    <ContactForm ref="contactForm"></ContactForm>
    <!-- Top -->
    <div class="b2">      
      <div class="b8"></div>
      <Header></Header>
      <div class="b6">
        <div class="img1">
          <carousel carouselFolder="home-scroll" />
        </div>        
        <div class="b12">
          <div class="b7">        
            <div v-if="!isMobile">
              <div :class="['t2','b9']">Community</div>
              <div :class="['t2','b10']">Family</div>
              <div :class="['t2','b11']">Friendship</div>
            </div>
            <div class="vspace2"></div>    
            <div >
              <div class="t4">{{p2}}</div>    
              <div class="vspace1"></div>
              <div class="t4">{{p3}}</div>    
              <div class="space1"></div>
              <!-- <div :class="['t4','hBtn','btn']" @click="$refs.contactForm.showForm()">Sign Up <img class="img2" src="/gallery/right-arrow.png" /></div> -->
            </div>   
          </div>        
        </div>
      </div>
      <div class="b8" v-if="!isMobile"></div>
      <div class="b8"></div>
    </div>
    <!-- INsight Interview -->
    <Youtube></Youtube>
    <div class="b50">

    </div>
    <!-- Hope For Acres -->
    <section :class="['font22', 'b15', 't4']">
      <div>      
        <h1 class="t8" v-if="!isMobile">Urgent Need - Hope for Acres!</h1>
        <h1 class="t8" v-else>Urgent Need<br>Hope for Acres!</h1>
        <p class="t4">We invite you to partner with Promise Land Community to purchase Promise Land Acres, a farm setting with residences, sustainable income, and community enrichment for individuals with intellectual and developmental disabilities and their families.</p>
        <p class="t4">For this dream to come to fruition,  we need your immediate partnership!</p>
        <button :class="['t3','btn1', 'btn2']"><a href="https://www.zeffy.com/en-US/donation-form/hope-for-acres " target="_blank">Learn More</a></button>
      </div>
      <div>
        <img class="b16" src="/gallery/hope-for-acres.jpg" />
      </div>
    </section>
    <!-- Our Services -->
    <div class="b100">
      <div class="b101">
        <h1 class="t8">Upcoming Events</h1>        
        <div v-if="!isMobile" :class="['t3','btn1']" @click="dispatch('events','events')">View All</div>
      </div>
      <div class="b102">          
        <div class="b103">
          <!-- <div :class="['btn', 't4']">&#8226; Resident Rehabilitation and Support</div>
          <div :class="['btn', 't4']">&#8226; Day Habilitation</div>
          <div :class="['btn', 't4']">&#8226; Respite</div>
          <div :class="['btn', 't4']">&#8226; Wellness Coordination</div> -->
          <div class="t4">{{ p4 }}</div>
        </div>
        <div class="b104" ref="b104" v-if="showImg3 && !isMobile">
          <img class="img3" ref="img3" src="/gallery/Services/1.jpg" />
        </div>        
      </div>
      <div class="b105">
        <div v-if="isMobile" :class="['t3','btn1']" @click="dispatch('events','events')">View All</div>
      </div>
    </div>
    <!-- Quote -->
    <div class="b210"> 
      <div class="b202">
        <h1 class="t8">What We Do</h1>
        <div class="t3">Weekly activities enhancing daily life skills and community.</div>
        <div :class="['b204']">
          <div :class="['b205','t4']">
            <div class="vspace1"></div>            
            <div class="vspace1"></div>    
            <div>Munchie Bunch</div>
            <img class="img5" src="/gallery/Home/1.jpg" />
            <div class="t4">A biweekly event focusing on friendship and daily life skills.</div>            
          </div>
          <div :class="['b205','t4']">
            <div class="vspace1"></div>    
            <div class="vspace1"></div>     
            <div>GLAD: Grace, Love, And Drums</div>
            <img class="img5" src="/gallery/Home/2.jpg" />
            <div class="t4">Every 1st and 3rd Thursday Friends gather to exercise with fun!</div>            
          </div>
        </div>
      </div>
      <!-- <div :class="['b201','t5']">{{ quote }}</div> -->
    </div>
    <!-- More Than a Dream -->
    <div class="b500">
      <h2 class="t8 b501">More Than a Dream</h2>
      <div class="b503">
        <iframe
          ref="dreamFrame"
          src="https://www.youtube.com/embed/JZQVF_0INTk?rel=0&controls=1&enablejsapi=1"
          title="More Than a Dream"
          style="width: 100%; height: 100%;"
          frameborder="0"
          allow="accelerometer; encrypted-media; web-share; gyroscope; picture-in-picture"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
    </div>
    <div class="b400">
      <div class="b401">
        <div :class="['t8','b402']">Want to Donate? <span class="space1"></span><span class="btn1" @click="dispatch('donate','donate')">Donate</span></div>
        <div class="vspace1"></div>
        <div class="t3">Every donation you contribute helps Promise Land grow and continue putting on events for our community!</div>
        <div class="t3">Also visit our registry for more detailed list of needs: <a href="https://www.myregistry.com/organization/promise-land-community-fremont-in/3209614" target="_blank">Promise Land Community Registry</a></div>  
        <!-- <span :class="['btn','link1']" @click="openLink('https://www.myregistry.com/organization/promise-land-community-fremont-in/3209614')">Promise Land Registry</span> -->
      </div>
    </div>
    <!-- Pancake Fundraiser -->
    <section :class="['font22', 'b13']">      
      <h1 class="t8">Community Comes Together for Pancake Breakfast Fundraiser Supporting Promise Land Community</h1>
      <h2 class="t9">“Who provides mentorship and guidance to individuals with disabilities and those who care for them?”</h2>
      <carousel-pancake class="b14" carouselFolder="pancake-scroll" />
      <p class="t4"><strong>Fremont, IN, July 26, 2025</strong> — The warmth of community spirit outshone even the threat of severe storms this past Saturday as Promise Land Community hosted their <b>3rd annual Pancake Breakfast Fundraiser</b> at Lakeland Commons. Despite unpredictable weather and last-minute changes, the event was a heartwarming success — raising both funds and community awareness for the unique programs supporting individuals with disabilities.</p>
      <p class="t4">Originally scheduled to be held under a large tent donated by <b>Steve Gard</b>, the event had to be quickly relocated due to an impending storm system. With impressive agility and teamwork, a group of over 30 volunteers sprang into action on Friday evening, cleaning and setting up a vacant building at Lakeland Commons, generously offered at the last minute by <b>Menno Wagner</b>.</p>
      <p class="t4"><b><i>“This is what community looks like,”</i></b> said a volunteer, reflecting on the weekend's efforts. <b><i>“We had just finished weeding and mulching the garden, preparing everything for the big day, then had to do it all again in a new space — and no one hesitated.”</i></b></p>
      <p class="t4">The event itself kicked off bright and early at 7 a.m., with the smell of sausages on the griddle and pancakes sizzling — all thanks to donations from groups like <b>Knights of Columbus</b>, <b>Arby's</b>, and the recently closed <b>Lake It Easy</b>, which contributed all the pancake mix. The turnout and support were overwhelming.</p>
      <p class="t4">One cherished moment stood out as a young man with autism joyfully served pancakes to guests, his eyes lighting up with the joy of contributing. <b><i>“Watching him connect and engage gave us all a powerful reminder of why we do this”</i></b>, said a team member from Promise Land.</p>
      <p class="t4">The breakfast fundraiser supports <b>activities</b> and <b>camps</b> for individuals with disabilities, helping them stretch beyond fear and anxiety, discover their unique gifts, and build meaningful friendships. Discussions even touched on future dreams — including a property featuring a <b>greenhouse</b>, a small <b>farm-to-fork operation</b>, and perhaps even a cozy <b>coffee house</b> where cookies (a community favorite) could be sold.</p>
      <p class="t4">The event was also an opportunity to raise awareness that <b>Promise Land</b> is growing — and they are actively seeking more space to realize these dreams.
          From <b>broadcast shares</b> with <b>WLKI</b> to <b>handmade wooden crafts</b> created with the <b>Northeastern Woodworkers</b>, the event represented more than just a breakfast. It was a celebration of purpose, perseverance, and the power of people coming together.</p>
      <p class="t4" style="margin-bottom:0;"><b><i>“To everyone in Steuben County who supported us — thank you,”</i></b> said organizers. <b><i>“Your belief in these remarkable individuals helps them to see just how capable, gifted, and valued they truly are.”</i></b></p>
    </section>
    <!-- Images -->
    <div class="b300">
      <img v-if="!isMobile" class="img4" src="/gallery/home-imgs/1.jpg" />
      <img class="img4" src="/gallery/home-imgs/2.jpg" />      
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Carousel from '../../Utilities/Carousel.vue';
import CarouselPancake from '../../Utilities/CarouselPancake.vue';
import Header from '../HeaderView.vue';
import Footer from '../FooterView.vue';
import ContactForm from '../../Utilities/ContactForm.vue';
import Youtube from '../../Utilities/Youtube.vue';
export default {
  name: 'home',
  components: {
    Carousel,    
    CarouselPancake,
    Header,
    Footer,
    ContactForm,
    Youtube,
  },
  data() {
    return {
      p2: 'Promise Land Community Inc. is a community that provides events, activities and opportunities for those living with disabilities.',
      p3: 'Come check out our upcoming events and learn more about what Promise Land is all about!',
      p4: 'At Promise Land Community, we have events every month to bring our community together. Some previous events that we hosted are a prom, birdhouse building, a trip to make apple cider, and more. If you would like to participate in our next event and to see a list of all events, visit our events page!',
      quote: '"...A Good Life, a meaningful life, a life with which we can enjoy the world and live with purpose, can only be built if we do more than live for ourselves." -Eric Greitans',
      showImg3: true,
      minWindowWidth: 20000,
    }
  },    
    mounted() {
      window.addEventListener('load', this.handleResize);
      window.addEventListener("resize", this.handleResize);
      this._dreamObserver = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) {
            try {
              this.$refs.dreamFrame.contentWindow.postMessage(
                JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }),
                '*'
              );
            } catch (e) { /* player may not be ready */ }
          }
        },
        { threshold: 0.1 }
      );
      this.$nextTick(() => {
        if (this.$refs.dreamFrame) {
          this._dreamObserver.observe(this.$refs.dreamFrame);
        }
      });
    },
    beforeUnmount() {
      if (this._dreamObserver) this._dreamObserver.disconnect();
      window.removeEventListener('load', this.handleResize);
      window.removeEventListener("resize", this.handleResize);
    },
    methods: {
      handleResize() {
        console.log('resize');
        console.log(this.minWindowWidth);
        console.log(window.innerWidth);          
        if(window.innerWidth > this.minWindowWidth) {
          this.minWindowWidth = 20000;
          this.showImg3=true;
        }
        if(this.$refs.b104 == null) return;   
        if(this.$refs.b104.clientWidth === this.$refs.img3.clientWidth) {
          this.minWindowWidth = window.innerWidth;
          this.showImg3 = false;          
        }
      }
    },
    created() {
      // this.handleResize();
      // window.scrollTo({
      //   top:0,
      //   left:0,
      //   behavior: 'smooth'
      // });
    }
}
</script>

<style scoped>
/* h1 {
  font-family: 'font1';
  font-weight: 500;
} */
.b1 {
  width:100%;
  height: fit-content;    
}
.b2 {
  position:relative;
  /* width:100%;
  padding-top:60px; */
  background-color: v-bind(color1);
  /* z-index: 99; */
  /* font-weight:700;
  line-height:1;
  font-size: calc((1.5-1) * 1vw + 1rem);
  padding-bottom:calc(v-bind(margin) * 1.5); */
}
.b3 {
  width:100%;
  height:200px;
  background-color: v-bind(color1);
}
.b5 {
  display:flex;
  position:absolute;
  right:0;  
  height:100%;
  align-items:center;
}
.b6 {
  display:flex;  
  margin-right:v-bind(margin1);
  margin-left:v-bind(margin1);
  margin-top:120px;  
}
.b7 {
  display:flex;
  flex-direction: column;
  justify-content:space-evenly;
  width:calc((100vw - (2 * v-bind(margin1))) * .45);
  /* margin-left:7.5%; */
}

.b8 {
  width:100%;
  height:60px;
  background-color: v-bind(color1);
}
.b10 {
  width: 100%;
  text-align:center;
}
.b11 {
  width: 100%;
  text-align: right;
}
.b12 {
  width: 100%;
  display:flex;
  justify-content: center;
}
.b13 {
  background-color: v-bind(color1);
  width: 100%;
  padding-left: v-bind(margin1);
  padding-right: v-bind(margin1);
  padding-top: 50px;
  padding-bottom: 50px;
  box-sizing:border-box;
  font-size: calc((1.2 - 1) * 1.2vw + 1rem);   
  font-weight: 300;
  overflow: hidden; /* Clearfix for floated content */
}
.b13 > h1, .b13 > h2 {
  margin-top: 0;
  font-family: 'font1';
  text-align: center;
}
.b13 > h2 {
  font-style: italic;
}
.b14 {
  float: right; margin-left: 15px;
}
.b15 {
  display: flex;
  align-items: center;  
  background-color: v-bind(color3);
  width: 100%;
  padding-left: v-bind(margin1);
  padding-right: v-bind(margin1);
  padding-top: 50px;
  padding-bottom: 50px;
  box-sizing:border-box;
  /* font-size: calc((1.2 - 1) * 1.2vw + 1rem);    */
  font-weight: 300;
  overflow: hidden;
}
.b15 > div > h1 {
  font-family: 'font1';  
  margin-top: 0 !important;
  font-weight: 400;
}
.b15 > div > p {
  font-weight: 300;
}
.b15 > div:nth-child(1) {
  width: 60%;
  margin-right: 20px;
}
.b15 > div:nth-child(2) {
  width: 40%;
}
.b16 {
  margin: 0;
  padding: 0;
  width: 100%;
}
/* Services */
.b100 {
  /* background-color: v-bind(color3); */
  display:flex;
  width:100%;
  margin-top:v-bind(margin1);
  margin-bottom:v-bind(margin1);
}
.b101 {  
  display:flex;
  flex-direction: column;
  padding:v-bind(margin1);
  justify-content: space-evenly;  
  width:fit-content !important;
  white-space:nowrap;
}
.b102 {
  position:relative;  
  display:flex;
  justify-content:space-between;
  width:100%;
  padding-top:30px;
  padding-bottom:30px;    
  box-sizing: border-box;
  border-left:2px solid black;
  /* padding:40px; */
  /* justify-content: space-between; */
}
.b103 {  
  /* width:50% !important; */
  margin-left:v-bind(margin1);
  display:flex;
  flex-direction: column;
  justify-content: space-evenly;  
  width:fit-content !important;
  /* align-items:center; */
  /* white-space:nowrap; */
}
.b104 {
  width:100%;
  display:flex;
  justify-content: center;
  align-items: center;
  overflow:hidden;
}

/* Quote */
.b210 {
  width: 100%;
  background-color: v-bind(color2);
  display:flex;
  flex-direction: column;
}
.b201 {
  /* padding-top:40px;
  padding-bottom:40px;
  padding-left: v-bind(margin);
  padding-right: v-bind(margin); */
  padding: calc(v-bind(margin1) * 2.5);
  text-align: center;
  color: v-bind(color3);
  font-style: italic;
}
.b202 {
  color: v-bind(color3);
  margin-right:v-bind(margin1);
  margin-left: v-bind(margin1);
  margin-top:50px;
  margin-bottom:50px;
}
.b203 {
  width:20%;
  margin-left:10%;
  height:100%;
  display:flex;
  flex-direction: column;
  justify-content: center;
  color:white;
}
.b204 {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.b205 {
  position:relative;
  display:block;
  width:35%;
}
/* More Than a Dream */
.b500 {
  width: 100%;
  background-color: v-bind(color1);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px v-bind(margin1);
  box-sizing: border-box;
}
.b501 {
  margin-top: 0;
  margin-bottom: 16px;
  color: v-bind(color3);
}
.b503 {
  height: 70vh;
  aspect-ratio: 9 / 16;
}
@media only screen and (max-width: 1152px) {
  .b503 {
    height: 60vh;
  }
}

/* Images */
.b300 {
  display:flex;
  width:100%;
}
.b400 {
  background-color:v-bind(color3);
}
.b401 {
  margin-left:v-bind(margin1);
  margin-right: v-bind(margin1);  
  padding-top:50px;
  padding-bottom:50px;
}
.b402 {
  display: flex;
}
.link1 {
  text-decoration: underline;
  text-underline-offset: 3px;
}
.p2 {
  font-size: calc((.8 * 1.2vw + 1rem));
  font-weight:100;
  font-family:'font2';
}

.btn1 > a {
  color: white;
  text-decoration: none;
}

.hBtn {
  width:fit-content;
  margin-top:40px;
  display:flex;
  align-items:center;
  text-decoration: underline; 
  text-decoration-thickness: 1.5px; 
}

.img1{
    /* width:45%; */
    /* max-height:50vh; */
    /* height:100% !important; */
    /* position:relative; */
    /* display:grid; */
    /* grid-template-columns: 1fr; */
    /* height:calc(vh - 180px) !important; */
}
.img2 {
  height: calc(.8 * 1vw + 1rem);
  margin-left:10px;
}
.img3 {
  height: calc(35vh + 1rem);
}
.img4 {
  width:50%;  
}
.img5 {
  width:100%;
}
.showImg {
  display:block;
}
.hideImg {
  display:none;
}

@media only screen and (max-width: 1152px) {
  .b6 {
    flex-direction: column;
    margin-top:70px;

  }
  .b7 {
    width:calc((100vw - (1 * v-bind(margin1))) * .7);
  }
  .b14 {
    float:none;
    margin: 0;
  }
  .b15 {
    flex-direction: column;
    padding: 5%;
    box-sizing: border-box;    
  }
  .b15 > div > h1 {
    text-align: center;
  }
  .b15 > div:nth-child(1), .b15 > div:nth-child(2) {
    width: 100%;
    padding: 0;
    margin: 0;    
  }
  .btn2 {
    margin: 0 auto;
  }
  .b16 {
    margin-top: 5%;
  }
  .b100 {
    flex-direction: column;
  }
  .b101 {
    flex-direction:row;
    width:100% !important;
    padding:0;
  }
  .b102 {
    border:none;
  }
  .b105 {
    width:100%;
    display:flex;
    justify-content: center;
  }
  .b201 {
    padding-left: calc(v-bind(margin1));
    padding-right: calc(v-bind(margin1));
  }
  .b204 {
    flex-direction: column;
    align-items: center;
  }
  .b205 {
    width:100%;
    margin-bottom:20px;
  }
  .img4 {
    width:100%;
  }
  .b300 {
    justify-content: center;
    background-color: v-bind(color2);
  }
  .t5 {
    display: flex;
    align-items: center;
  }
}
</style>